'use client';

import React, { createContext, useContext, ReactNode } from 'react';
import { useSearchParams } from 'next/navigation';

interface NukiDevicesContextType {
  nukiDevices: string | null; // `null` if the search param is not present
}

const NukiDevicesContext = createContext<NukiDevicesContextType>({ nukiDevices: null });

export function NukiDevicesProvider({ children }: { children: ReactNode }) {
  const searchParams = useSearchParams();
  const nukiDevices = searchParams.get('nukiDevices');

  return (
    <NukiDevicesContext.Provider value={{ nukiDevices }}>{children}</NukiDevicesContext.Provider>
  );
}

// Custom hook to use the context
export const useNukiDevices = () => useContext(NukiDevicesContext);
